"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AudienceInsightReportRowToJSON = exports.AudienceInsightReportRowFromJSONTyped = exports.AudienceInsightReportRowFromJSON = exports.instanceOfAudienceInsightReportRow = void 0;
var runtime_1 = require("../runtime");
var ReportEntityStatus_1 = require("./ReportEntityStatus");
var ReportField_1 = require("./ReportField");
/**
 * Check if a given object implements the AudienceInsightReportRow interface.
 */
function instanceOfAudienceInsightReportRow(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfAudienceInsightReportRow = instanceOfAudienceInsightReportRow;
function AudienceInsightReportRowFromJSON(json) {
    return AudienceInsightReportRowFromJSONTyped(json, false);
}
exports.AudienceInsightReportRowFromJSON = AudienceInsightReportRowFromJSON;
function AudienceInsightReportRowFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'name': !(0, runtime_1.exists)(json, 'name') ? undefined : json['name'],
        'id': !(0, runtime_1.exists)(json, 'id') ? undefined : json['id'],
        'status': !(0, runtime_1.exists)(json, 'status') ? undefined : (0, ReportEntityStatus_1.ReportEntityStatusFromJSON)(json['status']),
        'insightValue': !(0, runtime_1.exists)(json, 'insight_value') ? undefined : json['insight_value'],
        'stats': !(0, runtime_1.exists)(json, 'stats') ? undefined : (json['stats'].map(ReportField_1.ReportFieldFromJSON)),
    };
}
exports.AudienceInsightReportRowFromJSONTyped = AudienceInsightReportRowFromJSONTyped;
function AudienceInsightReportRowToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'name': value.name,
        'id': value.id,
        'status': (0, ReportEntityStatus_1.ReportEntityStatusToJSON)(value.status),
        'insight_value': value.insightValue,
        'stats': value.stats === undefined ? undefined : (value.stats.map(ReportField_1.ReportFieldToJSON)),
    };
}
exports.AudienceInsightReportRowToJSON = AudienceInsightReportRowToJSON;
